/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ComponentBluePrintDataContext } from '../models/component-blue-print-data-context';

@Injectable({
  providedIn: 'root',
})
export class CareFindrTenantConfigurationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getTenantComponentBluePrint
   */
  static readonly GetTenantComponentBluePrintPath = '/component-blueprint/{page_name}';

  /**
   * GET Tenant specific ComponentBlueprint.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTenantComponentBluePrint()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTenantComponentBluePrint$Response(params: {

    /**
     * Specifies the name of the page for which the component blueprint is being retrieved.
     */
    page_name: string;

    /**
     * The tenant name we will use as a key to lookup their config in MongoDB. Falls-back to default config if specified tenant not found.
     */
    tenant: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ComponentBluePrintDataContext>> {

    const rb = new RequestBuilder(this.rootUrl, CareFindrTenantConfigurationService.GetTenantComponentBluePrintPath, 'get');
    if (params) {
      rb.path('page_name', params.page_name, {});
      rb.header('tenant', params.tenant, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ComponentBluePrintDataContext>;
      })
    );
  }

  /**
   * GET Tenant specific ComponentBlueprint.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTenantComponentBluePrint$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTenantComponentBluePrint(params: {

    /**
     * Specifies the name of the page for which the component blueprint is being retrieved.
     */
    page_name: string;

    /**
     * The tenant name we will use as a key to lookup their config in MongoDB. Falls-back to default config if specified tenant not found.
     */
    tenant: string;
  },
  context?: HttpContext

): Observable<ComponentBluePrintDataContext> {

    return this.getTenantComponentBluePrint$Response(params,context).pipe(
      map((r: StrictHttpResponse<ComponentBluePrintDataContext>) => r.body as ComponentBluePrintDataContext)
    );
  }

}
